import { useAuth } from "./auth/auth.context";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const Unauthorized = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="space-y-4">
          <h1 className="text-4xl font-bold text-foreground">Access Denied</h1>
          <p className="text-lg text-foreground">
            You don't have the required permissions to access this page.
          </p>
          {user && (
            <p className="text-sm text-muted-foreground">
              Logged in as: {user.email}
            </p>
          )}
        </div>

        <div className="space-y-4">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="w-full"
          >
            Go Back
          </Button>
          <Button
            onClick={() => {
              logout();
              navigate("/signin");
            }}
            variant="destructive"
            className="w-full"
          >
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
};
